import ChooseHowDrawer from './ChooseHowDrawer';

export default ChooseHowDrawer;
